import { useAuth, SignIn } from '@clerk/clerk-react';
import React from 'react';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="text-text-secondary">Loading...</div>
      </div>
    );
  }

  if (!isSignedIn) {
    // Embedded, brand-themed sign-in (appearance is set on ClerkProvider).
    // `routing="hash"` keeps every sub-step (email verification, MFA,
    // password reset) on this domain without dedicated router routes.
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-4">
        <SignIn routing="hash" />
      </div>
    );
  }

  return <>{children}</>;
}
